const basePath = '/finance';

export const financeRoutes = {
  root: basePath,
  overview: `${basePath}/overview`,
  accounts: `${basePath}/financial-accounts`,
  balances: `${basePath}/balances`,
  bills: `${basePath}/bills`,
  billDetail: `${basePath}/bills/:id`,
  invoices: `${basePath}/invoices`,
  invoiceDetail: `${basePath}/invoices/:id`,
  payments: `${basePath}/payments`,
  paymentDetail: `${basePath}/payments/:id`,
} as const;
